import { ColorsEnum } from '../constants/colors'

export const getProductColor = (
    localReadyQuantity: number,
    totalQuantity: number,
    isLoading: boolean
) => {
    if (isLoading) {
        return ColorsEnum.GRAY
    }

    if (localReadyQuantity === 0) {
        return ColorsEnum.GRAY_DARK
    }

    if (localReadyQuantity === totalQuantity) {
        return ColorsEnum.SUCCESS
    }

    return ColorsEnum.SECONDARY_LIGHT
}
